import React from 'react';
import { ajaxGet, ajaxPost, AjaxResponseType } from '../../common/form/FrekulForm';
import { MusicEntity } from '../types/MusicEntityTypes';

export const defaultMusicClient = {
  removeMusic(musicId: number): Promise<AjaxResponseType> {
    return ajaxPost(`/musics/ajax_remove/${musicId}`, {}, {}, true);
  },
  saveMusicTitle(musicId: number, title: string): Promise<AjaxResponseType> {
    const postData: { [key: string]: File|string } = {};
    postData.title = title;
    return ajaxPost(`/musics/ajax_update/${musicId}`, postData, {}, true);
  },
  getMusicIsEditable(musicId: number): Promise<AjaxResponseType & { editable: boolean }> {
    return ajaxGet(`/musics/ajax_is_editable/${musicId}`);
  },
  getMusics(page: number): Promise<AjaxResponseType & {
    musics: MusicEntity[],
    artist: { allow_use: number },
  }> {
    return ajaxGet(`/musics/ajax_get_musics/${page}`);
  },
  saveBulkPermissionToUse(bulkPermissionToUse: number, defaultPermissionToUse: number): Promise<AjaxResponseType> {
    const postData: { [key: string]: File|string } = {};
    postData.music_allow_use = `${bulkPermissionToUse}`;
    postData.artist_allow_use = `${defaultPermissionToUse}`;
    return ajaxPost('/musics/ajax_update_allow_use_all', postData, {}, true);
  },
  savePermissionToUse(musicId: number, permissionToUse: number): Promise<AjaxResponseType> {
    const postData: { [key: string]: File|string } = {};
    postData.allow_use = `${permissionToUse}`;
    return ajaxPost(`/musics/ajax_update_allow_use/${musicId}`, postData, {}, true);
  },
  beginMusicUpload(audioFile: File, progressHandler: (progress: number) => void): Promise<AjaxResponseType & {
    music: MusicEntity & {
      upload_hash: string,
    },
  }> {
    const postData: { [key: string]: File|string } = {};
    postData.audio = audioFile;
    return ajaxPost('/musics/ajax_upload', postData, {
      progress: (info) => {
        progressHandler(info.progress);
      },
    });
  },
  rollbackMusicUpload(uploadHash: string): Promise<AjaxResponseType> {
    return ajaxPost(`/musics/ajax_upload_cancel/${uploadHash}`, {}, {}, true);
  },
  commitMusicUpload(uploadHash: string, title: string, permissionToUse: number): Promise<AjaxResponseType & {
    music: MusicEntity,
  }> {
    const postData: { [key: string]: File|string } = {};
    postData.title = title;
    postData.allow_use = permissionToUse ? '1' : '0';
    return ajaxPost(`/musics/ajax_upload_complete/${uploadHash}`, postData, {}, true);
  },
};

export const MusicClientContext = React.createContext(defaultMusicClient);

